import { render, staticRenderFns } from "./JPrompt.vue?vue&type=template&id=dfbfdf98&scoped=true"
import script from "./JPrompt.vue?vue&type=script&lang=js"
export * from "./JPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbfdf98",
  null
  
)

export default component.exports